import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.RefundConfigTemplate.Delete.IRequest;
type Response = Api.Core.RefundConfigTemplate.Delete.IResponse;
type Headers = Api.Core.RefundConfigTemplate.Delete.IHeaders;
const url = '/api/ProductManagement/RefundConfigTemplate/:id';
export default async function refundConfigTemplateDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
